import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
//import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';

import { ComponentsModule } from './components/components.module';
import { ExamplesModule } from './examples/examples.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesModule } from './page/pages.module';

//import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import { HttpClientModule} from "@angular/common/http";
import { AdminService } from './services/admin';
import { PopupModule } from 'ng2-opd-popup/components/popup';
import { CMSService } from './services/cms-service';
import { AuthGard } from './services/auth-gard.service';
//import { NgxEditorModule } from 'ngx-editor';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,

  //  HttpModule,
    //HttpClientModule
  ],
  imports: [
    BrowserModule,
    NgbModule.forRoot(),
    FormsModule,
    RouterModule,
    ComponentsModule,
    ExamplesModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PagesModule,
    HttpClientModule,
    HttpModule,
   // NgxEditorModule,
    //MDBBootstrapModule.forRoot(),
    
    PopupModule.forRoot()
  ],
  providers: [AdminService,CMSService,AuthGard],
  bootstrap: [AppComponent]
})
export class AppModule { }
